module.exports = function() {
  return new Worker(__webpack_public_path__ + "904478934a1bb472f6a8.worker.js");
};